import { SheetProvider } from "../SheetProvider";
import { ISheetField } from "../Models";



export interface ISheetProductInformation {
    type: string;
    level: string;
    productNumber: string;
    priceWithoutTax: Number; //decimal
}

export default class MatProvider extends SheetProvider {
    
    
    private products: any;



    public getFields() {
        var self = this;
        if (this.fields == null) {

            //static fields (could be parsed from WEB in future)
            this.products = {};

            //mat measurements (60 cm x 90 cm)
            this.addProduct('vaskeri', 'middel', '14216', 372.85);
            this.addProduct('plus', 'høj', '14220', 780.10);
            //mat measurements (60 cm x 90 cm)

            //mat measurements (90 cm x 150 cm)
            this.addProduct('budget', 'lav', '14219', 480);
            this.addProduct('vaskeri', 'middel', '14217', 962.25);
            this.addProduct('plus', 'høj', '14221', 1926.7);
            //mat measurements (90 cm x 150 cm)


            //mat measurements (130 cm x 200 cm)
            this.addProduct('budget', 'lav', '14415', 1230.15);
            this.addProduct('vaskeri', 'mid', '14539', 1848.85);
            this.addProduct('plus', 'høj', '14218', 3641.3);
            //mat measurements (130 cm x 200 cm)


            this.fields = {};

            //mat measurements (60 cm x 90 cm)
            //static fields product informations
            this.addField('P10', '', () => { return self.products['14216'].priceWithoutTax });
            this.addField('P11', '', () => { return self.products['14220'].priceWithoutTax });

            this.addField('H11', '', () => { return 60 });
            this.addField('J11', '', () => { return 24 });

            //user input field
            this.addField('E10', '', () => { return 0 });

            this.addField('E11', '', () => { return 0 });

            //antal måtter //E9 + E10
            this.addField('E12', '', () => {
                return self.fields['E10'].value() + self.fields['E11'].value();
            });


            this.addField('D12', '', () => {
                var val = self.fields['H11'].value() * self.fields['J11'].value() * self.fields['E12'].value();
                return val;
            });

            //Antal dgl. passager
            this.addField('F12', '', () => {
                //=SUM(E10*P10+E11*P11)
                var val = (self.fields['E10'].value() * self.fields['P10'].value()) 
                        + (self.fields['E11'].value() * self.fields['P11'].value()); 
                return val;
            });



            //end mat measurements (60 cm x 90 cm)



            //mat measurements (90 cm x 150 cm)
            //static fields product informations
            this.addField('P14', '', () => { return self.products['14219'].priceWithoutTax });
            this.addField('P15', '', () => { return self.products['14217'].priceWithoutTax });
            this.addField('P16', '', () => { return self.products['14221'].priceWithoutTax });

            this.addField('H16', '', () => { return 65 });
            this.addField('J16', '', () => { return 24 });
            //user input field
            this.addField('E14', '', () => { return 0 });
            this.addField('E15', '', () => { return 0 });
            this.addField('E16', '', () => { return 0 });

            //antal måtter
            this.addField('E17', '', () => {
                return self.fields['E14'].value() + self.fields['E15'].value() + self.fields['E16'].value();
            });

            this.addField('D17', '', () => {
                var val = self.fields['H16'].value() * self.fields['J16'].value() * self.fields['E17'].value();
                return val;
            });

            //Antal dgl. passager
            this.addField('F17', '', () => {
                //=SUM(E14*P14+E15*P15+E16*P16)
                var val = (self.fields['E14'].value() * self.fields['P14'].value())
                        + (self.fields['E15'].value() * self.fields['P15'].value())
                        + (self.fields['E16'].value() * self.fields['P16'].value()); //+(0 * self.fields['P15'].value)+(0* self.fields['P16'].value)
                return val;
            });

            //end mat measurements (90 cm x 150 cm)



            //mat measurements (130 cm x 200 cm)
            //static fields product informations
            this.addField('P19', '', () => { return self.products['14415'].priceWithoutTax });
            this.addField('P20', '', () => { return self.products['14539'].priceWithoutTax });
            this.addField('P21', '', () => { return self.products['14218'].priceWithoutTax });

            this.addField('H21', '', () => { return 75 });
            this.addField('J21', '', () => { return 24 });

            //user input field
            //TODO: add E10  ?
            this.addField('E19', '', () => { return 0 });
            this.addField('E20', '', () => { return 0 });
            this.addField('E21', '', () => { return 0 });

            //antal måtter
            this.addField('E22', '', () => {
                return self.fields['E19'].value() +self.fields['E20'].value() +self.fields['E21'].value();
            });

            this.addField('D22', '', () => {
                var val = self.fields['H21'].value() * self.fields['J21'].value() * self.fields['E22'].value();
                return val;
            });

            //Antal dgl. passager
            this.addField('F22', '', () => {
                var val = (self.fields['E19'].value() * self.fields['P19'].value())
                        + (self.fields['E20'].value() * self.fields['P20'].value())
                        + (self.fields['E21'].value() * self.fields['P21'].value()); //+(0 * self.fields['P20'].value)+(0* self.fields['P21'].value)
                return val;
            });

            //end mat measurements (130 cm x 200 cm)





            //sum of all measures
            this.addField('B22', '', () => {
                var val = self.fields['D12'].value() + self.fields['D17'].value() + self.fields['D22'].value();
                return val;
            });

            //renting price over 1 year
            this.addField('B26', '', () => {
                var val = self.fields['B22'].value();
                return val;
            });

            //renting price over 5 years
            var years = 5;
            this.addField('B26', '', () => {
                var val = self.fields['B22'].value() * years;
                return val;
            });

            //fixed price for x pcs of 
            this.addField('B28', '', () => {
                var val = self.fields['F12'].value() + self.fields['F17'].value() + self.fields['F22'].value();
                return val;
            });

            //your discount / saving
            this.addField('B30', '', () => {
                var val = self.fields['B26'].value() - self.fields['B28'].value();
                return val;
            });


        }
        return this.fields;
    }


    private addProduct(type: string, level: string, productNumber: string, priceWithoutTAX: Number) {
        this.products[productNumber] = <ISheetProductInformation>{
            type: type,
            level: level,
            productNumber: productNumber,
            priceWithoutTax: priceWithoutTAX
        };
    }


}

